import {
  CTA,
  Text,
  TextAlignment,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogTrigger,
} from '../components/ui/dialog';
import ArIcon from './ar-icon';
import QrCode from './qr-code';
import useMediaQuery from '../hooks/useMediaQuery';
import {useHistory} from 'react-router-dom';
import {useSendAmpChargeAnalytic} from '../hooks/useSendAmpChargeAnalytic';

const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding-left: 64px;
  padding-right: 64px;
  padding-top: 32px;
  padding-bottom: 64px;
  justify-content: center;
  border-radius: 8px;
  background-color: white;
`;

const Label = styled(Text)`
  color: #001e50;
  font-family: var(--font-family-text, vw-text);
`;

const Button = styled(CTA)`
  width: 233px;
  height: 56px;
  min-width: 233px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 56px;
  color: #001e50;

  &:hover:not(:disabled) {
    background-color: #00b0f0;
  }

  @media (max-width: 768px) {
    margin-top: 40px;
  }
`;

const ButtonContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

type Props = {
  isCustomers?: boolean;
};
const QrCodeDialog: React.FC<Props> = ({isCustomers}) => {
  const {isMobile} = useMediaQuery();
  const history = useHistory();
  const {handleViewInARClick} = useSendAmpChargeAnalytic();

  const onViewInARClick = () => {
    const targetPath = isCustomers ? '/customers/app' : '/app';
    history.push(targetPath);
    handleViewInARClick();
  };

  return (
    <Dialog>
      <ButtonContainer>
        {isMobile ? (
          <Button
            onClick={onViewInARClick}
            icon={<ArIcon color="#001E50" style={{marginRight: '2px'}} />}
            tag="button"
          >
            <Text
              appearance={TokenTextAppearance.label200}
              color={TokenTextColor.inherit}
            >
              View in AR
            </Text>
          </Button>
        ) : (
          <DialogTrigger asChild>
            <Button
              icon={<ArIcon color="#001E50" />}
              tag="button"
              onClick={handleViewInARClick}
            >
              <Text
                appearance={TokenTextAppearance.label200}
                color={TokenTextColor.inherit}
              >
                View in AR
              </Text>
            </Button>
          </DialogTrigger>
        )}
      </ButtonContainer>

      <DialogPortal>
        <DialogOverlay />
        <DialogContent>
          <Wrapper>
            <Label
              appearance={TokenTextAppearance.headline100}
              bold
              textAlign={TextAlignment.center}
            >
              Scan the QR code
            </Label>
            <QrCode />
          </Wrapper>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default QrCodeDialog;
